(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solice-brand-directory"] && !Shopify.designMode) return;
  try {
    
function initSoliceBrands(root){
if(root.dataset.ready)return;root.dataset.ready='true';
const input=root.querySelector('[data-brand-search]'),cards=[...root.querySelectorAll('.solice-brand-card')],rangeButtons=[...root.querySelectorAll('[data-brand-range]')],letters=[...root.querySelectorAll('[data-brand-letter-filter]')],more=root.querySelector('[data-brand-more]');
let category='all',letter='',expanded=false;
const normalize=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
letters.forEach(b=>b.disabled=!cards.some(c=>c.dataset.brandLetter===b.dataset.brandLetterFilter));
function update(){
const term=normalize(input.value),filtered=Boolean(term||category!=='all'||letter);let count=0;
cards.forEach(c=>{const match=(!term||normalize(c.dataset.brandName+' '+c.dataset.brandAliases).includes(term))&&(category==='all'||c.dataset.brandCategory===category)&&(!letter||c.dataset.brandLetter===letter);const visible=match&&(filtered||expanded||c.dataset.brandFeatured==='true');c.hidden=!visible;if(visible)count++;});
root.querySelectorAll('[data-brand-group]').forEach(g=>g.hidden=![...g.querySelectorAll('.solice-brand-card')].some(c=>!c.hidden));
root.querySelector('[data-brand-count]').textContent=root.dataset.countTemplate.replace('__COUNT__',String(count));root.querySelector('[data-brand-empty]').hidden=count>0;
rangeButtons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.brandRange===category)));letters.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.brandLetterFilter===letter)));
more.hidden=filtered;more.textContent=expanded?more.dataset.collapseLabel:more.dataset.expandLabel;
}
function reset(){input.value='';category='all';letter='';expanded=false;update();}
input.addEventListener('input',update);
rangeButtons.forEach(b=>b.addEventListener('click',()=>{category=b.dataset.brandRange;letter='';update();}));
letters.forEach(b=>b.addEventListener('click',()=>{letter=letter===b.dataset.brandLetterFilter?'':b.dataset.brandLetterFilter;update();}));
root.querySelector('[data-brand-clear]').addEventListener('click',()=>{input.value='';update();input.focus();});
root.querySelector('[data-brand-reset]').addEventListener('click',reset);
more.addEventListener('click',()=>{expanded=!expanded;update();});
root.querySelectorAll('[data-brand-jump]').forEach(a=>a.addEventListener('click',()=>{category=a.dataset.brandJump;letter='';input.value='';update();}));
update();
}
document.querySelectorAll('.solice-brand-directory').forEach(initSoliceBrands);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.solice-brand-directory').forEach(initSoliceBrands));

  } catch(e) { console.error(e); }
})();
})();
